import { render, staticRenderFns } from "./SHManagePolicy.vue?vue&type=template&id=54e4789a&"
import script from "./SHManagePolicy.vue?vue&type=script&lang=js&"
export * from "./SHManagePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports